import React from "react";
import TextField from "@mui/material/TextField";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";
import Autocomplete from "Components/UI/Form/Autocomplete";

export default function FilesCombobox({
  label,
  disabled,
  files,
  selectedFileID,
  onChange,
}) {
  const navigate = useNavigate();

  return (
    <Autocomplete
      value={files?.find((f) => f.Id === selectedFileID)}
      disabled={disabled}
      options={files}
      getOptionLabel={(f) => f.Name + "-" + f.Id}
      isOptionEqualToValue={(option, value) => {
        return option.Id === value?.Id || value == null;
      }}
      onChange={(event, newValue) => {
        onChange(newValue == null ? null : newValue.Id);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  display: selectedFileID ? "flex" : "none",
                }}
              >
                <IconButton
                  onClick={() => navigate(`/files/${selectedFileID}`)}
                  edge="end"
                >
                  <LinkIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          label={label ? label : ""}
        />
      )}
    />
  );
}
